import { KBEntity, SearchResult } from '../knowledge-base.type';
import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'antd/lib/form/Form';
import { queryKnowledgeBase } from '../../knowledge-base-common/actions';

interface SearchFromValues {
    query: string;
}

interface Options {
    resetTriggers: KBEntity[];
    onSearch: () => void;
    serviceUrl: string;
}

export const useSearch = ({ resetTriggers, onSearch, serviceUrl }: Options) => {
    const [form] = useForm<SearchFromValues>();
    const [results, setResults] = useState<SearchResult[] | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [query, setQuery] = useState<string>(null);

    useEffect(() => {
        setResults(null);
        setQuery(null);
    }, [...resetTriggers]);

    const search = useCallback(async ({ query }: SearchFromValues) => {
        if (!query) return;
        try {
            setIsLoading(true);
            const articles = await queryKnowledgeBase(serviceUrl, query);
            setQuery(query);
            setResults(articles);
            onSearch();
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    const clear = useCallback(() => {
        setResults(null);
        setQuery(null);
        form.resetFields();
    }, []);

    return { form, results, isLoading, query, search, clear };
};
